import type { GridPagination } from "@repo/ui";

export interface DisciplinesFilter extends GridPagination {
	brands?: (number | string)[];
	channels?: (number | string)[];
	marketers?: (number | string)[];
	states?: (number | string)[];
	branches?: (number | string)[];
	/** Rep Id (start of the login) or part of the rep's name */
	agent?: string;
	types?: RepDisciplineType[];
	/** true: active today, false: ended by today */
	active?: boolean | null;
	startDateFrom?: Date | null;
	startDateTo?: Date | null;
	endDateFrom?: Date | null;
	endDateTo?: Date | null;
	reasons?: RepDisciplineReason[];
	/** LMS course ids */
	trainingIds?: string[];
}

/** A row of the Disciplines grid (MVCDisciplineRow) */
export interface DisciplineRow {
	repDisciplineId: number;
	representativeId: number;
	representativeLogin: string;
	representativeName: string;
	type: RepDisciplineType;
	typeName: string;
	reason: RepDisciplineReason | null;
	reasonName: string | null;
	reasonText: string | null;
	startDate: Date | null;
	endDate: Date | null;
	segmentNames: string;
	assignedTrainingNames: string;
	relatedIncidentId: number | null;
	relatedIncidentIsComplaint: boolean;
	createdByName: string | null;
	createdOn: Date;
}

export interface DisciplineTraining {
	id: string;
	name: string;
}

// Match RepDisciplineType and RepDisciplineReason in TLP.Sync.Common.Entities
export enum RepDisciplineType {
	Probation = 1,
	Suspension = 2,
	Blocklist = 3,
	FeatureSuspension = 4,
}

export enum RepDisciplineReason {
	Complaint = 1,
	Onboarding = 2,
	InternalReview = 3,
	Alert = 4,
}
